import * as yup from "yup";

export const schema = (t: (val: string) => string) => {
    const validation = {
        name: yup
            .string()
            .max(50, t("cmn:val.maxLenght"))
            .required(t("cmn:val.required")),
    };

    return yup.object().shape({ ...validation });
};
